import { DocumentReference } from "firebase/firestore";
import { Moment } from "moment";

export default interface Assinatura {
  id: string;
  dataAssinatura: Moment;
  dataFinalCicloCobranca: Moment;
  situacao: SituacaoAssinatura;
  inicioAvaliacao: Moment;
  finalAvaliacao: Moment;
  plano: DocumentReference;
  quantidade: number;
}

export enum SituacaoAssinatura {
  TRIALING = "trialing",
  ACTIVE = "active",
  UNPAID = "unpaid",
  INCOMPLETE = "incomplete",
  INCOMPLETE_EXPIRED = "incomplete_expired",
  PAST_DUE = "past_due",
  CANCELED = "canceled",
}
